/**
 * @generated SignedSource<<affe14f06c5f0e1bbfafac900a73c5b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CoachClientCalendarRouteQuery$variables = {
  username: string;
};
export type CoachClientCalendarRouteQuery$data = {
  readonly client: {
    readonly displayName: string | null | undefined;
    readonly email: string | null | undefined;
    readonly username: string;
    readonly " $fragmentSpreads": FragmentRefs<"ChooseProgramEnrollDialog_client">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"CoachClientCalendarScreen_root">;
};
export type CoachClientCalendarRouteQuery = {
  response: CoachClientCalendarRouteQuery$data;
  variables: CoachClientCalendarRouteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "username"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "username",
    "variableName": "username"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "client",
    "variableName": "username"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 99
  }
],
v7 = [
  {
    "kind": "Literal",
    "name": "raw",
    "value": true
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v9 = {
  "kind": "Literal",
  "name": "utc",
  "value": true
},
v10 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "MMM DD, YYYY"
  },
  (v9/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CoachClientCalendarRouteQuery",
    "selections": [
      {
        "alias": "client",
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ChooseProgramEnrollDialog_client"
          }
        ],
        "storageKey": null
      },
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "CoachClientCalendarScreen_root"
      }
    ],
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CoachClientCalendarRouteQuery",
    "selections": [
      {
        "alias": "client",
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "EnrollmentConnection",
        "kind": "LinkedField",
        "name": "enrollments",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EnrollmentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Enrollment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": (v7/*: any*/),
                    "kind": "ScalarField",
                    "name": "startDate",
                    "storageKey": "startDate(raw:true)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Program",
                    "kind": "LinkedField",
                    "name": "program",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageURL",
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activities",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": (v7/*: any*/),
                        "kind": "ScalarField",
                        "name": "date",
                        "storageKey": "date(raw:true)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Component",
                        "kind": "LinkedField",
                        "name": "component",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "draft",
                                "value": true
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": "title(draft:true)"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "locked",
                            "storageKey": null
                          },
                          (v8/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "iconName",
                                "storageKey": null
                              }
                            ],
                            "type": "ComponentIcon",
                            "abstractKey": "__isComponentIcon"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "completed",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Enrollment",
                        "kind": "LinkedField",
                        "name": "enrollment",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "client",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Program",
                            "kind": "LinkedField",
                            "name": "program",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "startDateRaw",
                    "args": (v7/*: any*/),
                    "kind": "ScalarField",
                    "name": "startDate",
                    "storageKey": "startDate(raw:true)"
                  },
                  {
                    "alias": "startFromNow",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "format",
                        "value": "fromNow"
                      },
                      (v9/*: any*/)
                    ],
                    "kind": "ScalarField",
                    "name": "startDate",
                    "storageKey": "startDate(format:\"fromNow\",utc:true)"
                  },
                  {
                    "alias": "startDateShort",
                    "args": (v10/*: any*/),
                    "kind": "ScalarField",
                    "name": "startDate",
                    "storageKey": "startDate(format:\"MMM DD, YYYY\",utc:true)"
                  },
                  {
                    "alias": "endDateShort",
                    "args": (v10/*: any*/),
                    "kind": "ScalarField",
                    "name": "endDate",
                    "storageKey": "endDate(format:\"MMM DD, YYYY\",utc:true)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "client",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "filters": [],
        "handle": "connection",
        "key": "CoachClientCalendar_enrollments",
        "kind": "LinkedHandle",
        "name": "enrollments"
      }
    ]
  },
  "params": {
    "cacheID": "92694ef5a09760db326c0a93f5bd1b3b",
    "id": null,
    "metadata": {},
    "name": "CoachClientCalendarRouteQuery",
    "operationKind": "query",
    "text": "query CoachClientCalendarRouteQuery(\n  $username: String!\n) {\n  client: user(username: $username) {\n    username\n    email\n    displayName\n    ...ChooseProgramEnrollDialog_client\n    id\n  }\n  ...CoachClientCalendarScreen_root_42ijek\n}\n\nfragment CalendarComponentCard_component on Component {\n  title(draft: true)\n  type\n  status\n  locked\n  ...ComponentIcon_component\n}\n\nfragment ChangeEnrollmentStartDateDialog_enrollment on Enrollment {\n  id\n}\n\nfragment ChooseProgramEnrollDialog_client on User {\n  email\n  displayName\n}\n\nfragment ChooseProgramEnrollDialog_enrollments on EnrollmentConnection {\n  edges {\n    node {\n      program {\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment ClientCalendarProgramCard_enrollment on Enrollment {\n  id\n  startDateRaw: startDate(raw: true)\n  startFromNow: startDate(utc: true, format: \"fromNow\")\n  startDateShort: startDate(utc: true, format: \"MMM DD, YYYY\")\n  endDateShort: endDate(utc: true, format: \"MMM DD, YYYY\")\n  ...ClientSmallProgramCard_enrollment\n  ...ConfirmRemoveFromProgramDialog_enrollment\n  ...ChangeEnrollmentStartDateDialog_enrollment\n}\n\nfragment ClientSmallProgramCard_enrollment on Enrollment {\n  program {\n    name\n    imageURL\n    slug\n    id\n  }\n  client {\n    username\n    id\n  }\n}\n\nfragment CoachClientCalendarActivity_activity on Activity {\n  date(raw: true)\n  completed\n  component {\n    ...CalendarComponentCard_component\n    slug\n    type\n    id\n  }\n  enrollment {\n    client {\n      username\n      id\n    }\n    program {\n      slug\n      id\n    }\n    id\n  }\n}\n\nfragment CoachClientCalendarEnrollment_enrollment on Enrollment {\n  program {\n    name\n    id\n  }\n  ...ClientCalendarProgramCard_enrollment\n}\n\nfragment CoachClientCalendarScreen_root_42ijek on Root {\n  enrollments(client: $username, first: 99) {\n    edges {\n      cursor\n      node {\n        __typename\n        id\n      }\n    }\n    ...CoachClientCalendar_enrollments\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment CoachClientCalendar_enrollments on EnrollmentConnection {\n  edges {\n    node {\n      id\n      startDate(raw: true)\n      program {\n        name\n        id\n      }\n      activities {\n        id\n        date(raw: true)\n        component {\n          type\n          id\n        }\n        ...CoachClientCalendarActivity_activity\n      }\n      ...CoachClientCalendarEnrollment_enrollment\n    }\n  }\n  ...ChooseProgramEnrollDialog_enrollments\n}\n\nfragment ComponentIcon_component on ComponentIcon {\n  __isComponentIcon: __typename\n  iconName\n  type\n}\n\nfragment ConfirmRemoveFromProgramDialog_enrollment on Enrollment {\n  id\n  client {\n    displayName\n    id\n  }\n  program {\n    name\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "26cf26fc0c8bcc6ced58db95e1fa4040";

export default node;
